import { FieldType } from '@framework/core/Enums';
import { IEntityModelField, IEntityModel } from '@framework/interfaces/IEntityModel';
export interface IStockItemFields {
		id?: any;
		unitOfMeasureName?: any;
		stockItemTypeName?: any;
		status?: any;
		datestamp?: any;
		changedById?: any;
		unitOfMeasureId?: any;
		stockItemTypeId?: any;
		code?: any;
		name?: any;
		description?: any;
		minOrderQuantity?: any;
		packagingQuantity?: any;
		externalUrl?: any;
		generalLedgerId?: any;
		hierarchyId?: any;
		manufacturerModelNumber?: any;
}

export class StockItemFields extends Array<IEntityModelField> {
	public id: IEntityModelField = { name: "id", displayName: "Id", fieldType: FieldType.String, pattern: "NameGeneric", required: true, keyField: true };
	public unitOfMeasureName: IEntityModelField = { name: "unitOfMeasureName", displayName: "Unit Of Measure", fieldType: FieldType.String, readOnly: true, required: true };
	public stockItemTypeName: IEntityModelField = { name: "stockItemTypeName", displayName: "Type", fieldType: FieldType.String, readOnly: true };
	public status: IEntityModelField = { name: "status", displayName: "Status", fieldType: FieldType.Int, pattern: "NameGeneric", required: true };
	public datestamp: IEntityModelField = { name: "datestamp", displayName: "Datestamp", fieldType: FieldType.DateTime, pattern: "NameGeneric", required: true };
	public changedById: IEntityModelField = { name: "changedById", displayName: "Changed By Id", fieldType: FieldType.String, pattern: "NameGeneric", required: true };
	public unitOfMeasureId: IEntityModelField = { name: "unitOfMeasureId", displayName: "Unit Of Measure Id", fieldType: FieldType.String, pattern: "NameGeneric", required: true };
	public stockItemTypeId: IEntityModelField = { name: "stockItemTypeId", displayName: "Stock Item Type Id", fieldType: FieldType.String, pattern: "NameGeneric", required: true };
	public code: IEntityModelField = { name: "code", displayName: "Code", fieldType: FieldType.String, pattern: "NameGeneric", required: true };
	public name: IEntityModelField = { name: "name", displayName: "Name", fieldType: FieldType.String, pattern: "NameGeneric", required: true };
	public description: IEntityModelField = { name: "description", displayName: "Description", fieldType: FieldType.String, pattern: "NameGeneric", required: true };
	public minOrderQuantity: IEntityModelField = { name: "minOrderQuantity", displayName: "Min Order Quantity", fieldType: FieldType.Float, pattern: "NameGeneric", required: true };
	public packagingQuantity: IEntityModelField = { name: "packagingQuantity", displayName: "Packaging Quantity", fieldType: FieldType.Float, pattern: "NameGeneric", required: true };
	public externalUrl: IEntityModelField = { name: "externalUrl", displayName: "External Url", fieldType: FieldType.String, pattern: "NameGeneric" };
	public generalLedgerId: IEntityModelField = { name: "generalLedgerId", displayName: "General Ledger Id", fieldType: FieldType.String, pattern: "NameGeneric" };
	public hierarchyId: IEntityModelField = { name: "hierarchyId", displayName: "Hierarchy Id", fieldType: FieldType.String, pattern: "NameGeneric" };
	public manufacturerModelNumber: IEntityModelField = { name: "manufacturerModelNumber", displayName: "Manufacturer Model Number", fieldType: FieldType.String, pattern: "NameGeneric" };

	constructor() {
		super();
		this.push(this.id);
		this.push(this.unitOfMeasureName);
		this.push(this.stockItemTypeName);
		this.push(this.status);
		this.push(this.datestamp);
		this.push(this.changedById);
		this.push(this.unitOfMeasureId);
		this.push(this.stockItemTypeId);
		this.push(this.code);
		this.push(this.name);
		this.push(this.description);
		this.push(this.minOrderQuantity);
		this.push(this.packagingQuantity);
		this.push(this.externalUrl);
		this.push(this.generalLedgerId);
		this.push(this.hierarchyId);
		this.push(this.manufacturerModelNumber);
	}
}

export class StockItemDTO implements IEntityModel {
	protected stockItemName: string = "StockItemModel";
	protected stockItemKeyField: string = "id";
	protected stockItemDisplayName: string = "Stock Item|Stock Items";
	protected stockItemFields = new StockItemFields();
	public get name(): string { return this.stockItemName };
	public get keyField(): string { return this.stockItemKeyField };
	public get displayName(): string { return this.stockItemDisplayName };
	public get fields(): StockItemFields { return this.stockItemFields };

	constructor() {};
}
